export enum CAMPAIGN_TYPE {
  FreeWashing = 'freeWashing',
  FreeDrying = 'freeDrying'
}

export enum TEMPLATE_ID {
  FreeWashing = 'offering_dynamic_energy_offer_and_receive_cashback_free_washing',
  FreeDrying = 'offering_energy_contract_and_receive_cashback_free_drying'
}

export enum COOKIE_KEY {
  FreeWashing = 'subscribed-to-free-washing',
  FreeDrying = 'subscribed-to-free-drying'
}

export const CAMPAIGN_SENDER_NAME = 'Coolblue Energie';
export const CAMPAIGN_SENDER_EMAIL = 'noreply@coolblue-energie.nl';
